import { Component, ElementRef, ViewChild } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  inputs: ['items']
})

export class ListComponent {
    private items: Array<string>;

    @ViewChild('list') theList: ElementRef;

    public constructor(private http: Http, private route: ActivatedRoute) {}

    private keyPress(event: KeyboardEvent, i: number): boolean {
        let element = this.theList.nativeElement;
        let height = element.clientHeight;
        if(event.keyCode === 9 && i === (this.items.length - 1) && height < 299)
            this.items.push('');
        return true;
    }

    private removeItem(i: number): void {
        this.items.splice(i, 1);

        let token = localStorage.getItem('amt_flyer_token');
        let headers = new Headers();
        headers.append('Authorization', token);

        this.http.delete(environment.endpoint + '/list/remove/' + this.route.snapshot.params['id'] + '/' + i, {headers: headers})
            .map(res => res.json(), err => err.json())
            .subscribe(
                res => { console.log(res); },
                err => { console.log(err); }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/list/list.component.ts